module.exports = __webpack_public_path__ + "static/media/raasay-distillery-premises.8ffb2194.png";